import React, { Component } from 'react';
import ContentWrapper from '../../../components/Layout/ContentWrapper';

class PaymentAmountFormatter extends Component {
  render() {
    const {
      dependentValues: {
        FinalPrice: finalPrice,
        UnpaidAmount: unpaidAmount,
      },
    } = this.props;
    return (
      <ContentWrapper>
        {
          React.cloneElement(this.props.children, {
            value: finalPrice - unpaidAmount,
          })
        }
      </ContentWrapper>
    );
  }
}

export default PaymentAmountFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/SIPaymentList/PaymentAmountFormatter.jsx